import { GetServerSideProps } from 'next'
import SignInPageNew from '../../../../components/auth/sign-in/SignInPageNew'
import { LOCALE_KO } from '../../../../modules/i18n/config'
import { s_head } from '../../../../modules/i18n/strings/auto/wording'
import { getOgUrl, t } from '../../../../modules/utils'
import { redirectRoot } from '../../../_app'

export const SignIn = ({ ogData, isMobileServer }) => {
  return <SignInPageNew ogData={ogData} isMobileServer={isMobileServer} />
}

export default SignIn

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { lang = LOCALE_KO } = context.query
  const { jwt_token } = context.req.cookies

  if (jwt_token) {
    redirectRoot(context)
  }

  let userAgent: string | undefined

  if (context.req) {
    // if you are on the server and you get a 'req' property from your context
    userAgent = context.req.headers['user-agent'] // get the user-agent from the headers
  } else {
    userAgent = navigator.userAgent // if you are on the client you can access the navigator from the window object
  }

  const isMobileServer = userAgent
    ? Boolean(userAgent.match(/Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile|WPDesktop/i))
    : false

  const ogData = {
    title: t(s_head.student.title, lang),
    desc: t(s_head.student.desc, lang),
    ogUrl: getOgUrl({ lang, context: { pathname: context.resolvedUrl } }),
  }

  return {
    props: {
      ogData,
      isMobileServer,
    },
  }
}
